/* @flow */

import swal, { toastError, toastSuccess } from './swal';
import { DANGER_COLOR } from './constants';

const alertas = {
    excluirIrreversivel: (title: string) => swal.fire({
        title,
        text: 'Esta ação é irreversível.',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Não',
        confirmButtonColor: DANGER_COLOR,
        type: 'error',
        showCancelButton: true,
    }),
};


export const exibirToastError = (mensagem: string) => toastError.fire(mensagem);
export const exibirToastSucesso = (mensagem: string) => toastSuccess.fire(mensagem);

export default alertas;
